import { render, staticRenderFns } from "./RadioExtendedNum.vue?vue&type=template&id=4f4ba343&"
import script from "./RadioExtendedNum.vue?vue&type=script&lang=js&"
export * from "./RadioExtendedNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports